import { render, staticRenderFns } from "./VerProgramacionInformeModal.vue?vue&type=template&id=6184fc54&"
import script from "./VerProgramacionInformeModal.vue?vue&type=script&lang=ts&"
export * from "./VerProgramacionInformeModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports